module.exports = __webpack_public_path__ + "assets/img/cf16bfa71022cd047047076f66ec382c.png";